// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7878ace","455":"fc9f8d3b","977":"abd4f569"}[chunkId] + ".chunk.js";
};